import { render, staticRenderFns } from "./xiaoyu-detail.vue?vue&type=template&id=e7132a02&"
import script from "./xiaoyu-detail.vue?vue&type=script&lang=ts&"
export * from "./xiaoyu-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports